import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { DialogUtils } from "../../helper/dialog.helper";
import { CanvassActivity } from "./canvass-activity.helper";
import { CanvassDataProvider } from "../../data-provider/canvass.dp";
import { HouseOccupant } from "../../models/house-occupant.model";
import { SearchUtils } from "../../helper/search.helper";

let CanvassListComponent = {
    selector: "vcCanvassList",
    templateUrl: "/angular/components/canvass/canvass-list.component.html",
    bindings: {
        location: "=?",
    },
    controller: class CanvassListController {
        // * bindings for typescript compiler *
        public location?: any;
        // ************************************

        public essentialsMode: boolean;
        public personLink = true;
        public openCanvassDialog: (canvass: any, ev: object) => void;
        public filter: any;
        public canvassList: any[] = [];
        public canvassListLoading = true;
        public canvassFilter: any;

        private $scope: any;
        private $q: any;

        public navigationBarService: NavigationBarHelperService;
        private filterDataProvider: FilterDataProvider;
        private canvassDataProvider: CanvassDataProvider;
        private searchUtils: SearchUtils;
        private canvassActivity: CanvassActivity;
        private dialog: DialogUtils;

        constructor(
            $scope: any,
            NavigationBarHelperService: NavigationBarHelperService,
            FilterDataProvider: FilterDataProvider,
            CanvassDataProvider: CanvassDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            SearchUtils: SearchUtils,
            CanvassActivity: CanvassActivity,
            DialogUtils: DialogUtils,
            $q: any
        ) {
            this.$scope = $scope;
            this.$q = $q;

            this.navigationBarService = NavigationBarHelperService;
            this.filterDataProvider = FilterDataProvider;
            this.canvassDataProvider = CanvassDataProvider;
            this.searchUtils = SearchUtils;
            this.canvassActivity = CanvassActivity;
            this.dialog = DialogUtils;

            this.essentialsMode =
                CampaignDataProvider.activeCampaign.campaignstatusid == "5";
            this.openCanvassDialog = this.canvassActivity.openCanvassDialog;
        }

        $onInit() {
            if (this.location) {
                this.setup();
            }

            this.$scope.$watch(
                () => this.filter,
                (newValue, oldValue) => {
                    if (
                        newValue &&
                        !angular.equals(
                            newValue.nonEmptyValues(),
                            oldValue.nonEmptyValues()
                        )
                    ) {
                        this.setLocalFilter();
                    }
                },
                true
            );
        }

        setup(): void {
            this.navigationBarService.setFilterBarOpen(false);
            this.navigationBarService.toggleFilterButton(false);
            this.filter = this.filterDataProvider.filter;

            if (this.filter.search && this.filter.search.values) {
                this.searchUtils.searchText = this.filter.search.values;
            }

            this.searchUtils.setSearchBar(
                "Search Interactions",
                (searchText) => {
                    this.filter.search = { values: searchText };
                    return this.$q.resolve([]); //Not using the results for the search dropdown so return empty.
                },
                null,
                true
            );

            this.canvassDataProvider.setLocationId(this.location.id);
            this.setLocalFilter();
        }

        deleteCanvass(canvass: object, ev: object): void {
            this.canvassActivity.deleteCanvass(
                canvass,
                this.canvassDataProvider,
                ev
            );
        }

        openViewHouseOccupantDialog(
            houseoccupant: HouseOccupant,
            ev: object
        ): void {
            this.dialog
                .show({
                    component: "vc-view-house-occupant",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    clickOutsideToClose: false,
                    locals: {
                        selectedHoid: houseoccupant.hoid,
                    },
                    ariaLabel: "View Person",
                    size: "large",
                })
                .then((data: HouseOccupant) => (houseoccupant = data));
        }

        setLocalFilter(): void {
            this.canvassFilter = _.cloneDeep(this.filter);
            this.canvassDataProvider.setFilters(this.canvassFilter);
        }
    },
};

angular
    .module("canvass")
    .component(CanvassListComponent.selector, CanvassListComponent);
